import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

// Encadré lecture seule « Équipement requis pour ce programme » (inscription publique). Aucun prix.
export function EquipementRequisBox({ program }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!program) return;
    fetch(`${API}/api/program-equipment/public/${program}`).then((r) => r.json()).then(setData).catch(() => setData(null));
  }, [program]);
  if (!data?.ok) return null;
  const groups = data.groups.filter((g) => g.items.length);
  if (!groups.length) return null;
  return (
    <div className="border border-white/10 bg-white/[0.03] p-4 mt-4" data-testid="equipement-requis-box">
      <p className="kz-mono text-[10px] tracking-[0.16em] uppercase text-white/40">Équipement pour {data.label}</p>
      <div className="grid sm:grid-cols-3 gap-3 mt-2">
        {groups.map((g) => (
          <div key={g.category} data-testid={`erb-${g.category}`}>
            <div className={`text-xs font-bold uppercase mb-1 ${g.category === "obligatoire" ? "text-[#F59E0B]" : g.category === "recommande" ? "text-white/70" : "text-sky-300"}`}>{g.label}</div>
            <ul className="space-y-0.5">{g.items.map((it) => <li key={it.id} className="text-sm text-white/80">• {it.label}{it.colors?.length ? <span className="text-white/40"> — {it.colors.join(" / ")}</span> : null}</li>)}</ul>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-white/40 mt-3">Aucun achat requis pour le cours d'essai. Les tailles sont confirmées au dojo avant toute commande.</p>
    </div>
  );
}
